import { useMemo, useRef, useState } from 'react';
import { ExecutorPlaceholder } from '../../../../components/OptionsExecutor/OptionsExecutor';
import sort_icon from './img/sort_icon.svg';
import sort_icon_top from './img/sort_icon_top.svg';
import { ButtonWithIcon } from '../../../../components/Buttons/ButtonWithIcon/ButtonWithIcon';
import { InputSearch, Checkbox, Tabs } from '@lk-gtcom/ecomlab-components';
import { ModalComponent } from '../../../../components/Modal/ModalComponent/ModalComponent';
import './ModalListExecutor.scss';

const btn_tab = [
  { label: 'Исполнитель', value: 'executor' },
  { label: 'Инициатор', value: 'author' },
  { label: 'Соисполнитель', value: 'co_executor' },
];

const ModalListExecutor = ({
  executors,
  setIsModal,
  setSelectedExecutor,
  setSelectedCoExecutor,
  selectedExecutor,
  selectedCoExecutor,
  selectedAuthor,
  setSelectedAuthor,
  setColumnsAreUpdating,
  updateData,
}) => {
  const [executorOptions, setExecutorOptions] = useState(executors);
  const [executorSearchValue, setExecutorSearchValue] = useState('');
  const [isSort, setIsSort] = useState(false);
  const [direction, setDirection] = useState(null);
  const checkboxRef = useRef();
  const email = localStorage.getItem('email');
  const [pageValue, setPageValue] = useState(btn_tab[0].value);

  const current_list_executors = (id) => {
    if (pageValue === 'executor') {
      return selectedExecutor?.includes(id);
    }
    if (pageValue === 'co_executor') {
      return selectedCoExecutor?.includes(id);
    }
    if (pageValue === 'author') {
      return selectedAuthor?.includes(id);
    }
  };

  const current_className_executors = (id) => {
    if (pageValue === 'executor') {
      return selectedExecutor?.includes(id)
        ? 'executor-item_active'
        : 'executor-item';
    }
    if (pageValue === 'co_executor') {
      return selectedCoExecutor?.includes(id)
        ? 'executor-item_active'
        : 'executor-item';
    }
    if (pageValue === 'author') {
      return selectedAuthor?.includes(id)
        ? 'executor-item_active'
        : 'executor-item';
    }
  };

  const currentListExecuters = useMemo(() => {

    let executor_list = executorOptions?.filter((e) => {
      // if (!e?.[pageValue]) return false;

      const nameLowerCased = e?.name.toLowerCase();
      return executorSearchValue
        ? nameLowerCased.includes(executorSearchValue.toLowerCase())
        : true;
    });
    if (direction) {
      return executor_list
        ?.sort((el1, el2) => {
          if (el1.name.toLowerCase() > el2.name.toLowerCase()) {
            return direction === 'ASC' ? 1 : -1;
          }
          if (el1.name.toLowerCase() < el2.name.toLowerCase()) {
            return direction === 'ASC' ? -1 : 1;
          }
          return 0;
        })
        .sort(
          (a, b) => current_list_executors(b.id) - current_list_executors(a.id)
        );
    } else {
      return executor_list.sort(
        (a, b) => current_list_executors(b.id) - current_list_executors(a.id)
      );
    }
  }, [executorOptions, direction, executorSearchValue, pageValue]);

  const selectedCount = useMemo(() => {
    if (pageValue === 'executor') {
      return selectedExecutor?.length || 0;
    }
    if (pageValue === 'co_executor') {
      return selectedCoExecutor?.length || 0;
    }
    if (pageValue === 'author') {
      return selectedAuthor?.length || 0;
    }
    return 0;
  }, [pageValue, selectedExecutor, selectedCoExecutor, selectedAuthor]);

  return (
    <ModalComponent
      right
      title='Выбор сотрудников'
      onClose={(e) => {
        setIsModal();
        updateData();
      }}
      style={{
        maxWidth: '500px'
      }}
      isNoData={!currentListExecuters?.length && !executorSearchValue}
      child={
          <div className="modal-list-executor">
            <div className="modal-list-executor__content">

              <div className="modal-list-executor__toolbar">
                <InputSearch
                  placeholder="Найти сотрудника"
                  value={executorSearchValue}
                  onChange={setExecutorSearchValue}
                />

                <ButtonWithIcon
                  size='m'
                  icon={direction === 'ASC' ? sort_icon : sort_icon_top}
                  onClick={(e) => {
                    if (!isSort) setIsSort(true);
                    setDirection(direction === 'ASC' ? 'DESC' : 'ASC');
                  }}
                />
              </div>

              <Tabs
                tabs={btn_tab}
                stopRedirect
                pageValue={pageValue}
                setPageValue={setPageValue}
              />

              <div className="executor-content__info">
                <p className="text">
                  Сотрудников - <span>{currentListExecuters?.length}</span>
                </p>
                <p className="text_bluee">
                  Выбрано - <span>{selectedCount}</span>
                </p>
              </div>

              <div className="executor-content">
                  <div className="executors-list-content">
                    <div className="list-executor">
                      {currentListExecuters?.map(
                        ({ id, name, login, color, role }) => (
                          <label
                            className={current_className_executors(id)}
                            key={id}
                            onClick={(e) => {
                              e.stopPropagation();
                              checkboxRef?.current?.click();
                            }}
                          >
                            <Checkbox
                              value={current_list_executors(id)}
                              ref={checkboxRef}
                              onClick={(e) => {
                                if (pageValue === 'executor') {
                                  setSelectedExecutor((prev) =>
                                    prev?.includes(id)
                                      ? prev?.filter((el) => el !== id)
                                      : [...prev, id]
                                  );
                                }
                                if (pageValue === 'co_executor') {
                                  setSelectedCoExecutor((prev) =>
                                    prev?.includes(id)
                                      ? prev?.filter((el) => el !== id)
                                      : [...prev, id]
                                  );
                                }
                                if (pageValue === 'author') {
                                  setSelectedAuthor((prev) =>
                                    prev?.includes(id)
                                      ? prev?.filter((el) => el !== id)
                                      : [...prev, id]
                                  );
                                }
                                if (typeof setColumnsAreUpdating === 'function') {
                                  setColumnsAreUpdating(true);
                                }
                              }}
                            ></Checkbox>
                            <ExecutorPlaceholder
                              name={name}
                              email={login}
                              color={color}
                              isShowInfo
                            />
                          </label>
                        )
                      )}
                    </div>
                  </div>
              </div>
            </div>
          </div>
      }
    />
  );
};

export { ModalListExecutor };
